import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { IProfilePicture } from '../interface/profilePicture';
type UploadProfilePictureWithParams = {
  data: FormData;
  params?: Record<string, string>;
};
const uploadProfilePicture = async ({
  data,
}: UploadProfilePictureWithParams): Promise<IProfilePicture> => {
  return post(API_URLS.UPLOAD_PROFILE_PICTURE, data);
};

export const useUploadProfilePicture = (): UseMutationResult<
  IProfilePicture,
  AxiosError<{ message?: string; type?: string }>,
  UploadProfilePictureWithParams
> => {
  const { setIsLoading } = useLoading();

  return useMutation({
    mutationFn: uploadProfilePicture,
    onMutate: () => {
      setIsLoading(true);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
